.overlay {
  position: var(--haus-paymentModal__overlay__position, fixed);
  inset: var(--haus-paymentModal__overlay__inset, 0);
  z-index: var(--haus-paymentModal__overlay__z-index, 2147483647);
  display: var(--haus-paymentModal__overlay__display, flex);
  align-items: var(--haus-paymentModal__overlay__align-items, center);
  justify-content: var(--haus-paymentModal__overlay__justify-content, center);
  background-color: var(--haus-paymentModal__overlay__background-color, rgba(0, 0, 0, 0.5));
  animation: var(--haus-paymentModal__overlay__animation, paymentModalOverlayShow 150ms ease-out);
}

.content {
  position: var(--haus-paymentModal__content__position, fixed);
  z-index: var(--haus-paymentModal__content__z-index, 2147483647);
  top: var(--haus-paymentModal__content__top, 50%);
  left: var(--haus-paymentModal__content__left, 50%);
  transform: var(--haus-paymentModal__content__transform, translate(-50%, -50%));
  min-width: var(--haus-paymentModal__content__min-width, min(320px, 90vw));
  max-width: var(--haus-paymentModal__content__max-width, 90vw);
  max-height: var(--haus-paymentModal__content__max-height, 90vh);
  overflow-y: var(--haus-paymentModal__content__overflow-y, auto);
  padding: var(--haus-paymentModal__content__padding, 24px);
  background-color: var(--haus-paymentModal__content__background-color, #fff);
  border-radius: var(--haus-paymentModal__content__border-radius, 8px);
  box-shadow: var(--haus-paymentModal__content__box-shadow, 0 4px 20px rgba(0, 0, 0, 0.15));
  animation: var(--haus-paymentModal__content__animation, paymentModalContentShow 150ms ease-out);

  @media (min-width: 768px) {
    min-width: var(--haus-paymentModal__content__min-width, 420px);
  }
}

.title {
  margin: var(--haus-paymentModal__title__margin, 0 0 16px 0);
  font-size: var(--haus-paymentModal__title__font-size, 1.25rem);
  font-weight: var(--haus-paymentModal__title__font-weight, 600);
}

@keyframes paymentModalOverlayShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes paymentModalContentShow {
  from {
    opacity: 0;
    transform: translate(-50%, -48%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
